import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getCommonInfo, putPAIAD010UpdateMatching } from '../../services/Api';

const initialState = {
    savedPAEAA010Conditions: [],
    savedPAEAA010History: [],
};

export const fetchInitialConditions = createAsyncThunk(
    'PAEAA010/fetchInitialConditions',
    async (_, { rejectWithValue }) => {
        try {
            const { data } = await getCommonInfo();
            if (data.matchRecruit) {
                const parsed = JSON.parse(data.matchRecruit);
                return Array.isArray(parsed) ? parsed : [parsed];
            }
            return [];
        } catch (error) {
            return rejectWithValue(error.message);
        }
    },
);

export const saveMatchingConditions = createAsyncThunk(
    'PAEAA010/saveMatchingConditions',
    async (memberSeq, { getState, rejectWithValue }) => {
        try {
            const savedPAEAA010Conditions = getState().PAEAA010.savedPAEAA010Conditions;
            const matchingData = JSON.stringify(savedPAEAA010Conditions);
            const response = await putPAIAD010UpdateMatching({ seq: memberSeq, matching: matchingData });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    },
);

const PAEAA010Slice = createSlice({
    name: 'PAEAA010Reducer',
    initialState,
    reducers: {
        saveFilterPAEAA010Conditions: (state, action) => {
            const newCondition = {
                checkedStoreValues: action.payload.checkedValues,
                checkedLikeRightStoreValues: action.payload.checkedLikeRightValues,
                startStoreDate: action.payload.startDate,
                endStoreDate: action.payload.endDate,
                savedStoreDate: action.payload.savedDate,
                checkedStoreLabels: action.payload.checkedLabels,
                applyMethodStore: action.payload.applyMethod,
                activeTabIndex: action.payload.activeTabIndex,
                activeTabCheckbox: action.payload.activeTabCheckbox,
                activeTabCheckbox2: action.payload.activeTabCheckbox2,
            };
            state.savedPAEAA010Conditions.push(newCondition);

            if (state.savedPAEAA010Conditions.length > 5) {
                state.savedPAEAA010Conditions.shift();
            }
        },

        deleteFilterPAEAA010Conditions: (state, action) => {
            const index = action.payload;
            if (index >= 0 && index < state.savedPAEAA010Conditions.length) {
                state.savedPAEAA010Conditions.splice(index, 1);
            }
        },

        updateFilterPAEAA010Conditions: (state, action) => {
            const { index, updatedCondition } = action.payload;
            if (index >= 0 && index < state.savedPAEAA010Conditions.length) {
                state.savedPAEAA010Conditions[index] = {
                    ...state.savedPAEAA010Conditions[index],
                    ...updatedCondition,
                };
            }
        },

        savePAEAA010History: (state, action) => {
            const { id } = action.payload;

            if (id) {
                const updatedHistory = state.savedPAEAA010History.filter((savedId) => savedId !== id);

                updatedHistory.unshift(id);

                if (updatedHistory.length > 5) {
                    updatedHistory.pop();
                }
                state.savedPAEAA010History = updatedHistory;
            }
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchInitialConditions.fulfilled, (state, action) => {
            state.savedPAEAA010Conditions = action.payload;
        });
        builder.addCase(saveMatchingConditions.fulfilled, (state, action) => {});
    },
});

export const {
    saveFilterPAEAA010Conditions,
    deleteFilterPAEAA010Conditions,
    savePAEAA010History,
    updateFilterPAEAA010Conditions,
} = PAEAA010Slice.actions;
export default PAEAA010Slice.reducer;
